import React, { memo } from "react";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { IExtendedMetric } from "@modules/ServiceProviders/types/serviceProvider.types";
import { MetricCard } from "../MetricCard";
import { MetricProgressBar } from "../MetricProgressBar";
import { MetricProgressFooter } from "../MetricProgressFooter";
import messages from "../messages";

interface IPromiseKeeperCard {
  metric: IExtendedMetric | undefined;
  onClick?: () => void;
}

export const PromiseKeeperCard = memo(({ metric, onClick }: IPromiseKeeperCard) => {
  const value = Number(metric?.value ?? 0);
  const threshold = Number(metric?.threshold ?? 85);
  const reached =
    metric !== undefined && metric.value !== null && value >= threshold;

  const closedServicesCount =
    metric?.computationDetails?.closedServicesCount ?? 0;
  const cancelledServicesCount =
    metric?.computationDetails?.cancelledServicesCount ?? 0;

  return (
    <MetricCard
      title={<FormattedMessage {...messages.promiseKeeperTitle} />}
      description={
        <FormattedMessage
          {...messages.minThreshold}
          values={{ value: threshold }}
        />
      }
      state={reached ? "reached" : "not-reached"}
      onClick={onClick}
      percentage={value}
      footer={
        <MetricProgressFooter
          text={
            <FormattedMessage
              {...messages.cancellationFooter}
              values={{ count: cancelledServicesCount, total: closedServicesCount }}
            />
          }
        />
      }
    >
      <MetricProgressBar value={value} threshold={threshold} />
    </MetricCard>
  );
});

PromiseKeeperCard.displayName = "PromiseKeeperCard";
